import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-[14px] sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_4 = { class: "px-4 py-5 sm:p-6 bg-white z-20" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-2" }
const _hoisted_6 = { class: "overflow-hidden bg-white" }
const _hoisted_7 = { class: "overflow-hidden bg-white" }
const _hoisted_8 = {
  key: 0,
  class: "card col-span-2 xl:col-span-1"
}
const _hoisted_9 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-[14px] sm:px-6 bg-white overflow-hidden relative" }
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-5 xl:grid-cols-2" }
const _hoisted_14 = { class: "overflow-hidden bg-white" }
const _hoisted_15 = { class: "overflow-hidden bg-white" }
const _hoisted_16 = { class: "card col-span-2 min-w-0" }
const _hoisted_17 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-[14px] sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_18 = { class: "flex-shrink-0" }
const _hoisted_19 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_20 = { class: "md:hidden !font-normal mt-4" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "md:hidden mt-4" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 1 }

import api from '@/utilities/api'

	import {
		isDueOnReceipt,
		isPayable,
		showStatusBadge,
		invoiceStatusColor,
		invoiceStatusLabel,
		clearPendingVerification,
		applyInvoiceDueStatus,
		amountDueWithoutProcessingFee,
		sumAmountDue
	} from '@/utilities/invoiceStatus'

	import {
		showsLicensing
	} from '@/utilities/typeOfWork'

	import {
		Auth
	} from 'aws-amplify'

	// store
	import {
		store as _userStore
	} from '@/store/user'

	// components
	import {
		ArrowDownTrayIcon as ArrowDownTrayIconMini,
		ListBulletIcon as ListBulletIconMini
	} from "@heroicons/vue/20/solid"

	import InvoiceDetailsButton from "../Invoices/components/InvoiceDetailsButton.vue"
	import PayButton from '../Invoices/components/PayButton.vue'
	import BlogPostPopup from './components/BlogPostPopup.vue'

	// vue
	import {
		ref,
		computed,
		onMounted
	} from "vue"

	
	const __default__ = { name: 'DashboardMain' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const userStore = _userStore()

	const loading = ref(true)
	const invoices = ref<Array<any>>([])
	const licenses = ref<Array<any>>([])

	// the same rule as the sidebar menu, so the card and the menu item come and go together. the
	// dashboard payload already carries the licenses, so no separate lookup is needed here
	const showLicensing = computed(() => {
		return showsLicensing(userStore?.user?.cognitoUser?.attributes?.["custom:typeOfWork"], licenses.value.length > 0)
	})

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	})

	// derived from the invoice list rather than accumulated while fetching, so refetching after a
	// payment recalculates the totals instead of adding to the previous run's values
	const totalOutstanding = computed(() => sumAmountDue(invoices.value))

	const totalPastDue = computed(() => {
		return sumAmountDue(invoices.value.filter((invoice: any) => invoice.isOverdue))
	})

	onMounted(() => {
		getDashboard()
	})

	// pulls the dashboard payload for the logged in contact out of FileMaker
	async function fetchDashboardData() {
		const user = await Auth.currentAuthenticatedUser()

		const body = {
			action: "getDashboard",
			payload: {
				id: user.attributes['custom:fm_contact_id'],
			}
		}
		const response = await api("post", "fmDataAPI", "/fmDataAPI", body)
		const scriptResult = JSON.parse(response.response.scriptResult)

		return scriptResult.result.data
	}

	async function getDashboard() {
		try {
			loading.value = true

			const todayDate = new Date()
			const dashboardData = await fetchDashboardData()

			licenses.value = dashboardData.licenses ?? []
			let _invoices = dashboardData.invoices


			_invoices = _invoices.filter((invoice: any) => {
				return invoice?.status === "Invoiced"
			})

			_invoices.forEach((invoice: any) => {
				//  split invoices summaries string
				invoice.summaries = invoice.summaries.split("\r")

				applyInvoiceDueStatus(invoice, todayDate)
			})

			invoices.value = _invoices
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}


return (_ctx: any,_cache: any) => {
  const _component_card_header_backdrop = _resolveComponent("card-header-backdrop")!
  const _component_tw_simple_stat = _resolveComponent("tw-simple-stat")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tw_badge_flat = _resolveComponent("tw-badge-flat")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-full mb-5 flex justify-between" }, [
      _createElementVNode("h1", { class: "text-3xl font-black text-dbBlue" }, " Dashboard ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["card col-span-2", {'xl:col-span-1': showLicensing.value}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "card-heading" }, " Payments ")
          ], -1)),
          _createVNode(_component_card_header_backdrop, { class: "opacity-30" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("dl", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_tw_simple_stat, {
                loading: loading.value,
                label: "Past Due",
                "value-class": "text-red-600"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(currencyFormatter).format(totalPastDue.value)), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_tw_simple_stat, {
                loading: loading.value,
                label: "Total Outstanding"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(currencyFormatter).format(totalOutstanding.value)), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ])
      ], 2),
      (showLicensing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "card-heading" }, " Licensing ")
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  href: 'https://accounts.claris.com/software/license/' + licenses.value[0]?.key,
                  target: "_blank"
                }, [
                  _createVNode(_component_tw_button, { class: "btn-base btn-indigo w-44" }, {
                    icon_right: _withCtx(() => [
                      _createVNode(_unref(ArrowDownTrayIconMini), { class: "w-5 h-5" })
                    ]),
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createTextVNode(" Download License "))
                    ]),
                    _: 1,
                    __: [1]
                  })
                ], 8, _hoisted_11)
              ]),
              _createVNode(_component_card_header_backdrop, { class: "opacity-30" })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("dl", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_tw_simple_stat, {
                    loading: loading.value,
                    label: "License Expires"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(licenses.value[0]?.expirationDate), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_tw_simple_stat, {
                    loading: loading.value,
                    label: "Days Until Expiration",
                    unit: "Days Remaining"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(licenses.value[0]?.daysToExpire), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "card-heading" }, " Current Invoices ")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_link, { to: {name: 'Invoices'} }, {
              default: _withCtx(() => [
                _createVNode(_component_tw_button, { class: "btn-base btn-indigo w-44" }, {
                  icon_right: _withCtx(() => [
                    _createVNode(_unref(ListBulletIconMini), { class: "w-5 h-5" })
                  ]),
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createTextVNode(" View All Invoices "))
                  ]),
                  _: 1,
                  __: [3]
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_card_header_backdrop, { class: "opacity-20" })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_tw_table, {
            data: invoices.value,
            loading: loading.value,
            placeholder: "No Open Invoices"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: "Invoice #",
                prop: "invoiceNumber",
                "class-name": "font-bold text-gray-900"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row.invoiceNumber) + " ", 1),
                  _createElementVNode("div", _hoisted_20, [
                    (_unref(showStatusBadge)(row))
                      ? (_openBlock(), _createBlock(_component_tw_badge_flat, {
                          key: 0,
                          color: _unref(invoiceStatusColor)(row)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(invoiceStatusLabel)(row)), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row.paymentTerms), 1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, { header: "Amount Due" }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: _normalizeClass({'text-red-600': row.isOverdue, 'text-yellow-600' : !row.isOverdue && row.status === 'Invoiced'})
                  }, _toDisplayString(_unref(currencyFormatter).format(_unref(amountDueWithoutProcessingFee)(row))), 3),
                  _createElementVNode("div", _hoisted_22, [
                    (!_unref(isDueOnReceipt)(row.paymentTerms))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(row.dueDate), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(row.paymentTerms), 1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                "class-name": "hidden md:table-cell",
                "header-class-name": "hidden md:table-cell",
                header: "Invoice Date",
                prop: "invoiceDate"
              }),
              _createVNode(_component_tw_table_column, {
                header: "Due Date",
                "header-class-name": "hidden md:table-cell",
                "class-name": "hidden md:table-cell",
                prop: "dueDate"
              }, {
                default: _withCtx(({row}) => [
                  (!_unref(isDueOnReceipt)(row.paymentTerms))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(row.dueDate), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.paymentTerms), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                "class-name": "hidden md:block",
                "header-class-name": "hidden md:block",
                header: "Status",
                prop: "status"
              }, {
                default: _withCtx(({row}) => [
                  (_unref(showStatusBadge)(row))
                    ? (_openBlock(), _createBlock(_component_tw_badge_flat, {
                        key: 0,
                        color: _unref(invoiceStatusColor)(row)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(invoiceStatusLabel)(row)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row.paymentTerms), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                "class-name": "hidden md:table-cell w-44",
                "header-class-name": "hidden md:table-cell sr-only w-44",
                header: "Pay"
              }, {
                default: _withCtx(({ row }) => [
                  (_unref(isPayable)(row) && !loading.value)
                    ? (_openBlock(), _createBlock(PayButton, {
                        key: 0,
                        invoice: row,
                        onSubmitted: getDashboard,
                        onVerificationCanceled: ($event: any) => (_unref(clearPendingVerification)(row))
                      }, null, 8, ["invoice", "onVerificationCanceled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                header: "View Details",
                "header-class-name": "sr-only",
                "class-name": "text-center md:text-right"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(InvoiceDetailsButton, { invoice: row }, null, 8, ["invoice"]),
                  (_unref(isPayable)(row) && !loading.value)
                    ? (_openBlock(), _createBlock(PayButton, {
                        key: 0,
                        class: "md:hidden mt-4",
                        invoice: row,
                        onSubmitted: getDashboard,
                        onVerificationCanceled: ($event: any) => (_unref(clearPendingVerification)(row))
                      }, null, 8, ["invoice", "onVerificationCanceled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading"])
        ])
      ])
    ]),
    _createVNode(BlogPostPopup)
  ]))
}
}

})